import { barLength, shownBar } from '../../utils/microscopy/scaleBar';

/*
 * What a scale looks like over a micrograph, inside an SVG whose viewBox is the
 * picture's own pixels (MicroscopyViewer's overlay, MicroscopeCanvas's surface),
 * so it magnifies with the picture and is always true to it:
 *   the bar        a round length drawn from the image's um_per_px, only when
 *                  it has one. No scale, no bar.
 *   the reference  the line a person drew along the bar burned into the picture
 *                  (scale_ref_line, migration 0111), with the length they typed
 *   a line in hand the bar being drawn now, not saved yet (`draft`)
 */
const COLOUR = '#E69F00'; // Okabe-Ito orange: the palette's mark colour, seen on a bright or a dark slide

function ReferenceLine({ line, um, unit, testId }) {
  const px = barLength(line);
  if (!px) return null;
  const [[x1, y1], [x2, y2]] = line;
  // Ticks across the two ends: the line's length is what counts, so its ends must read.
  const tx = (-(y2 - y1) / px) * unit * 4;
  const ty = ((x2 - x1) / px) * unit * 4;
  return (
    <g data-testid={testId} data-px={Math.round(px)} pointerEvents="none" stroke={COLOUR} strokeWidth={unit} strokeLinecap="round">
      <line x1={x1} y1={y1} x2={x2} y2={y2} />
      <line x1={x1 - tx} y1={y1 - ty} x2={x1 + tx} y2={y1 + ty} />
      <line x1={x2 - tx} y1={y2 - ty} x2={x2 + tx} y2={y2 + ty} />
      {um ? (
        <text x={(x1 + x2) / 2} y={Math.min(y1, y2) - unit * 6} textAnchor="middle" fontSize={unit * 12} fill={COLOUR}
              stroke="#000" strokeWidth={unit * 0.4} style={{ paintOrder: 'stroke' }}>{um} µm</text>
      ) : null}
    </g>
  );
}

export default function ScaleBarMark({ image, width, height, draft = null, unit = null, bar = true }) {
  const W = width || image?.width_px || 100;
  const H = height || image?.height_px || 100;
  const u = unit || Math.max(W, H) / 400;
  const shown = bar ? shownBar(image) : null;
  return (
    <>
      {shown && (
        <g data-testid="scale-bar" pointerEvents="none">
          <rect x={W - shown.px - 24} y={H - 30} width={shown.px} height={8} fill="#fff" stroke="#000" strokeWidth={1} />
          <text x={W - shown.px / 2 - 24} y={H - 36} textAnchor="middle" fontSize={Math.max(12, H / 25)} fill="#fff"
                stroke="#000" strokeWidth={0.6}>{shown.um} µm</text>
        </g>
      )}
      {!draft && image?.scale_ref_line && (
        <ReferenceLine line={image.scale_ref_line} um={image.scale_ref_um} unit={u} testId="scale-reference" />
      )}
      {draft && <ReferenceLine line={draft} unit={u} testId="scale-draft" />}
    </>
  );
}
